import { Brand } from "@/types/brand";
import Image from "next/image";

const BrandsDesktop = ({ brandsData }: { brandsData: Brand[] }) => {
  return (
    <div className="flex flex-nowrap items-center justify-between">
      {brandsData.map((brand) => (
        <SingleBrand key={brand.id} brand={brand} />
      ))}
    </div>
  );
};

export default BrandsDesktop;

const SingleBrand = ({ brand }: { brand: Brand }) => {
  const { href, image, imageLight, name } = brand;

  // Custom dimensions for different logos
  let dimensions = "h-24 w-64"; // Default for Akamai
  if (name === "CME Group") {
    dimensions = "h-40 w-[600px]"; // Much larger for CME
  } else if (name === "BpiFrance") {
    dimensions = "h-40 w-96"; // Larger for BPI
  }

  return (
    <div className="flex items-center justify-center">
      <a
        href={href}
        target="_blank"
        rel="nofollow noreferrer"
        className={`relative ${dimensions} transition hover:opacity-75`}
      >
        {imageLight && (
          <Image 
            src={imageLight} 
            alt={name} 
            fill 
            className="hidden object-contain dark:block" 
            sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
            priority
          />
        )}
        <Image 
          src={image} 
          alt={name} 
          fill 
          className="block object-contain dark:hidden" 
          sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
          priority
        />
      </a>
    </div>
  );
}; 